/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */
import React from 'react';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import cancelIcon from '../../../../assets/images/Icon-cancel.png';
import { getDateMMDDYYYTimeStamp } from '../../../../SharedModules/DateUtilities/DateUtilities';
import { PaperComponent } from '../../../../SharedModules/utilities/utilities';

const {
  REACT_APP_PRODUCT_NAME: PRODUCTNAME,
  REACT_APP_VERSION: VERSION,
  REACT_APP_MESSAGE_TEXT: MESSAGE,
  REACT_APP_BUILT_TIMESTAMP: TIMESTAMP,
  REACT_APP_COPYRIGHT_YR: COPYRIGHT_YR,
  REACT_APP_COPYRIGHT_TEXT: COPYRIGHT_TEXT,
} = process.env;

function AboutModal({ open, dialogTitle, okAction, closeModal }) {
  const { t } = useTranslation();
    const currentYear = new Date().getFullYear();

  return (
    <div className="about-dialog">
      <Dialog
        className="table-dialog-popup dialogPanel custom-check custom-dialog"
        open={open}
        onClose={(reason) => {
          if (reason === 'backdropClick' && reason === 'escapeKeyDown') {
            okAction(true);
          }
        }}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle
          className="copy-contact-title"
          style={{ cursor: 'move' }}
          id="draggable-dialog-title"
        >
          <div className="float-left dialog-heading-txt mt-1">
            {dialogTitle}
          </div>
          <div
            className="close-popup-icon float-right"
            role="button"
            onClick={() => closeModal(false)}
          >
            <img alt="" src={cancelIcon} />
          </div>
        </DialogTitle>
        <DialogContent style={{ overflow: 'hidden' }}>
          <div className="mui-custom-form">
            <img
              src="/bottom_logo.png"
              alt="conduent logo"
              className="about_logo"
            />
          </div>
          <div>
            <p className="about-text">{t(PRODUCTNAME)}</p>
          </div>
          <div style={{ fontWeight: 'bold' }}>
            <p className="about-text">{t(`Version ${VERSION}`)}</p>
          </div>
          <div>
            <p className="about-text">{t(MESSAGE)}</p>
          </div>
          <div>
            <p className="about-text">
              {t('Built on ')}
              {getDateMMDDYYYTimeStamp(TIMESTAMP)}
            </p>
          </div>
          <div>
            <p className="about-text">
            {`@${currentYear} ${process.env.REACT_APP_COPYRIGHT_TEXT}`}
            </p>
          </div>
        </DialogContent>

        <DialogActions>
          <Button color="primary" onClick={() => okAction(false)}>
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default AboutModal;
